/** One (prompt, platform) pair for Overview "Top prompts by platform" (Option B). */
export interface TopPromptByPlatformItem {
  platform: string;
  query: string;
  answer_text: string;
  mentioned_brands: string[];
  citations: any[];
  cited_domains?: string[];
}

/** Platform key to display label (Overview, dialog, Discovery Citations). */
export const PLATFORM_LABELS: Record<string, string> = {
  chatgpt: 'ChatGPT',
  gemini: 'Gemini',
  ai_overview: 'AI Overview',
  ai_mode: 'AI Mode'
};
